import {
  orderClient,
  type SearchOrderFilterModel,
  type TimeslotOrderGroupModel,
} from '@merchant-clients/order';

import { useClientQuery } from '@frontend/hooks';

const fetchTimeslotOrders = (
  filter: SearchOrderFilterModel,
): Promise<TimeslotOrderGroupModel[]> => {
  return orderClient.listTimeslot({ filter });
};

export const getTimeslotOrdersQueryKey = (
  filter: SearchOrderFilterModel,
): string[] => [
  'orders-timeslot',
  filter.shopId,
  `${filter.period.from}:${filter.period.to ?? ''}`,
  (filter.status ?? []).join(','),
  (filter.placeIds ?? []).join(','),
];

export interface UseTimeslotOrdersQueryProps {
  filter: SearchOrderFilterModel;
  enabled: boolean;
  onError?(error: Error): void;
}

export const useTimeslotOrdersQuery = ({
  filter,
  enabled,
  onError,
}: UseTimeslotOrdersQueryProps) => {
  return useClientQuery({
    queryKey: getTimeslotOrdersQueryKey(filter),
    enabled: enabled && !!filter.shopId,
    async onFetch() {
      return fetchTimeslotOrders({
        period: filter.period,
        placeIds: filter.placeIds,
        status: filter.status,
        shopId: filter.shopId,
        orderIds: filter.orderIds,
        verificationIds: filter.verificationIds,
      });
    },
    onError,
    refetchInterval: 10000,
  });
};
